import apiClient from './apiClient';

export interface QueueCommandRequest {
  characterIds: string[];
  type: string;
  data?: any;
}

export interface QueueCommandResponse {
  success: boolean;
  enqueuedFor: number;
  skipped: number;
}

export interface FetchCommandsResponse {
  commands: Array<{
    type: string;
    data: any;
  }>;
}

export interface CommandsStatusResponse {
  totalCommands: number;
}

export interface CharacterCommandsStatusResponse {
  characterId: string;
  queueSize: number;
}

/**
 * Queue commands for one or more characters
 */
export async function queueCommands(characterIds: string[], type: string, data?: any): Promise<QueueCommandResponse> {
  if (!Array.isArray(characterIds)) {
    const errMsg = `queueCommands: characterIds must be an array. Received: ${JSON.stringify(characterIds)} (type: ${typeof characterIds})`;
    console.error(errMsg);
    throw new Error(errMsg);
  }

  console.log(`queueCommands: characterIds=${JSON.stringify(characterIds)}, type=${type}, data=${JSON.stringify(data)}`);
  const response = await apiClient.post<QueueCommandResponse>('/commands/enqueue', {
    characterIds: characterIds,
    type: type,
    data: data ?? {},
  });
  return response.data;
}

/**
 * Fetch commands for a specific character (public endpoint - used by bots)
 */
export async function fetchCommands(characterId: string): Promise<FetchCommandsResponse> {
  const response = await apiClient.get<FetchCommandsResponse>(`/commands/fetch/${characterId}`);
  return response.data;
}

/**
 * Get overall commands status (authenticated)
 */
export async function getCommandsStatus(): Promise<CommandsStatusResponse> {
  const response = await apiClient.get<CommandsStatusResponse>('/commands/status');
  return response.data;
}

/**
 * Get commands status for a specific character (authenticated)
 */
export async function getCharacterCommandsStatus(characterId: string): Promise<CharacterCommandsStatusResponse> {
  const response = await apiClient.get<CharacterCommandsStatusResponse>(`/commands/status/${characterId}`);
  return response.data;
}
